module.exports = __webpack_public_path__ + "48f2a9293c694377453b76c08e270787.MP3";